import request from '@/services/request'
import store from '@/store'
import { getApiUrl, getEventApiUrl, getGameApiUrl } from '@/utils/tool'

export function getCategory() {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/category',
    method: 'post'
  })
}

export function getGames(object, customConfig) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/',
    method: 'post',
    data: object,
    customConfig
  })
}

// 全量遊戲清單（走 ETag 快取）：頁面載入時多處同時呼叫共用同一次請求，避免重複下載、互相蓋寫快取；語系不同才另外打
let allGamesCache = { language: null, request: null }
export function getAllGames() {
  const language = store.getters.language
  if (allGamesCache.language !== language || !allGamesCache.request) {
    const pending = getGames({}, { noLoading: true, etagCache: true })
    allGamesCache = { language, request: pending }
    // 請求結束就放掉，下次呼叫再向後端確認版本（有 ETag 會回 304）
    const release = () => {
      if (allGamesCache.request === pending) {
        allGamesCache = { language: null, request: null }
      }
    }
    pending.then(release, release)
  }
  return allGamesCache.request
}

export function getGamesV2(object) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/v2',
    method: 'post',
    data: object
  })
}

export function getGameList(object, customConfig) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/list',
    method: 'post',
    data: object,
    customConfig
  })
}

// 最愛遊戲清單：layout 與首頁都要取，最愛 id 相同時共用同一次請求的結果，id 有變才重打
let favoriteGameListCache = { key: null, request: null }
export function getFavoriteGameList(gameIds, customConfig) {
  const key = JSON.stringify([...new Set(gameIds)].sort((a, b) => a - b))
  if (favoriteGameListCache.key !== key) {
    const pending = getGameList({ game_id_list_string: key }, customConfig)
    favoriteGameListCache = { key, request: pending }
    // 失敗不留快取，下次再重打
    pending.catch(() => {
      if (favoriteGameListCache.request === pending) {
        favoriteGameListCache = { key: null, request: null }
      }
    })
  }
  return favoriteGameListCache.request
}

// 清掉最愛遊戲清單快取，下次取用會重打 API
export function clearFavoriteGameListCache() {
  favoriteGameListCache = { key: null, request: null }
}

export function getProviderGame() {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/provider',
    method: 'post'
  })
}

export function getGameNum() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/game/num',
    method: 'post'
  })
}

export function gameLaunch(obj) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/launch',
    method: 'post',
    data: obj
  })
}

export function gameBetRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/bet-record-v2',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function withdrawal(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/withdrawal',
    method: 'post',
    data: object
  })
}
export function deposit(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/deposit',
    method: 'post',
    data: object
  })
}

export function gameLeave(game_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/leave',
    method: 'post',
    data: { game_id: game_id }
  })
}

